<template>
    <div class='altrama-extension'>
        <loading loader="svg" :active.sync="isLoading" :opacity="0.8" :height="200" :width="200" color="#5c7990"
            :can-cancel="false" :is-full-page="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" height="200" width="200" fill="#5c7990">
                <rect x="1" y="13" width="4" height="4">
                    <animate attributeName="width" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="1; 0; 1" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="13; 12; 13" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
                <rect x="10" y="13" width="6" height="6">
                    <animate attributeName="width" attributeType="XML" values="6; 4; 6" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="6; 4; 6" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="10; 11; 10" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="12; 13; 12" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
                <rect x="20" y="13" width="3" height="3">
                    <animate attributeName="width" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="height" attributeType="XML" values="4; 6; 4" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="x" attributeType="XML" values="21; 20; 21" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="y" attributeType="XML" values="13; 12; 13" begin="0s" dur="0.6s"
                        repeatCount="indefinite"></animate>
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                        calcMode="linear" repeatCount="indefinite"></animate>
                </rect>
            </svg>
        
        </loading>

        <div>
            <div class="p8 title">
                <h2 id="catalogo">prodotti</h2>
            </div>
            <div class="d-flex flex-wrap search-bar p8">
                <div class="p-0 col-lg-26 col-md-24 col-sm-30">
                    <input type="text" placeholder="cerca tra i prodotti" v-model="inputText">
                </div>
                <div class="p-0 col-lg-4 col-md-6 col-sm-30">
                    <input class="w-100" type="button" value="cerca" v-on:click="search()">
                </div>
            </div>

            <div class="accordion-title p8">filtra per</div>

            <div class="accordion" id="accordion">
                <div class="panel">


                    <div id="collapsefiltraper" class="collapse" aria-labelledby="filtraper" data-parent="#accordion">
                    <div class="d-flex flex-wrap"> 
                            <!-- prezzo -->
<!--                             <div class="p8 filter-col col-lg-7 col-md-10 col-sm-30 price-col">
                                <div class="col-title"><span>prezzo</span></div>
                                <div class="price">
                                    <input type="range" :min="prezzi.min" :max="prezzi.max" v-model="inputPrice">
                                </div>
                                <div class="d-flex flex-wrap justify-content-between">
                                    <div><span>{{prezzi.min}} €</span></div>
                                    <div><span>{{prezzi.max}} €</span></div>
                                </div>                                
                            </div> -->
                            <!-- autori -->
 
                            <div class="p8 col-lg-10 col-md-15 col-sm-30">
                                <div class="d-flex flex-wrap">
                                    <!-- inizio select -->
                                    <div class="col-title"><span>autore</span></div>
                                    <select
                                        title="nessuna selezione"
                                        multiple
                                        data-live-search="true"
                                        data-live-search-placeholder="Cerca autore"
                                        v-model="autoriSelezionati"
                                    >
                                        <option v-for="autore in autori" :value="autore" :key="autore">
                                            {{autore}}
                                        </option>
                                    </select>
                                    <!-- fine select -->

                                </div>
                            </div>               
                                                            
                            <!-- categorie -->
                            <div class="p8 col-lg-10 col-md-15 col-sm-30">
                                <div class="d-flex flex-wrap">
                                    <!-- inizio select -->
                                    <div class="col-title"><span>categoria</span></div>
                                    <select
                                        title="nessuna selezione"
                                        multiple
                                        data-live-search="true"
                                        data-live-search-placeholder="Cerca categoria"
                                        v-model="categorieSelezionate"
                                    >
                                        <option v-for="categoria in categorie" :value="categoria.id" :key="categoria.id" :class="categoria.class">
                                            {{categoria.title}}
                                        </option>
                                    </select>
                                    <!-- fine select -->

                                </div>
                            </div>  


                            <!-- tematismi -->
                            <div class="p8 filter-col col-lg-10 col-md-15 col-sm-30">
                                <div class="col-title"><span>tematismo<span></div>
                                <div class="first-level-cell" v-for="tematismo in tematismi" v-bind:key="tematismo.id" v-on:click="tematismoSel(tematismo)">
                                    <div class="first-level-title cursor-pointer"><span>{{tematismo.title}} </span> <span v-show="showTematismoX(tematismo)">x</span></div>
                                </div>
                            </div>                                                                                                                                                                        
                        </div>
                    </div>

                    <div class="p8 panel-heading" role="tab" id="filtraper">
                        <div class="panel-title">
                            <div class="collapsed d-flex justify-content-end cursor-pointer" data-toggle="collapse" data-target="#collapsefiltraper" aria-expanded="true" aria-controls="collapseOne">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                                    </svg>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>

            <div class="accordion-title p8">ordina per</div>

            <div class="accordion" id="accordion2">
                <div class="panel">


                    <div id="collapseordinaper" class="collapse" aria-labelledby="ordinaper" data-parent="#accordion2">
                        <div class="d-flex flex-wrap"> 
                            <div class="p8 col-lg-10 col-md-10 col-sm-30" v-for="ordinamento in ordinamenti" v-bind:key="ordinamento">
                                <div class="cursor-pointer"><span class="col-title" v-on:click="order(ordinamento)">{{ordinamento}} </span><span v-show="showOrderArrow(ordinamento)">{{orderArrow(ordinamento)}}</span></div>
                            </div>
                                                                                                                                                                    
                        </div>
                    </div>

                    <div class="p8 panel-heading" role="tab" id="ordinaper">
                        <div class="panel-title">
                            <div class="collapsed d-flex justify-content-end cursor-pointer" data-toggle="collapse" data-target="#collapseordinaper" aria-expanded="true" aria-controls="collapseOne">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                                    </svg>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>        

            <div class="d-flex flex-wrap results">
                <div class="p16 col-lg-6 col-md-10 col-sm-30" v-for="risultato in risultati" v-bind:key="risultato">
                    <div class="block-title">
                        <a :href="risultato.link"><h3>{{risultato.title}}</h3></a>
                        <h4>{{risultato.subtitle}}</h4>
                    </div>
                    <div class="block-image">
                        <a :href="risultato.link">
                            <img :class="risultato.imageclass" :src="risultato.imagelink" :alt="risultato.title">
                        </a>
                    </div>
<!--                     <div class="block-description">
                        <span>{{risultato.description}}</span>
                    </div> -->
                    <div class="block-price">
                        <span>{{risultato.price}} euro</span>
                    </div>
                    <div class="block-scopri">
                        <a :href="risultato.link">
                            <svg class="arrowright" viewBox="0 0 1656 1256"><path d="M1400 361c-1-12-6-24-14-33l-413-439c-18-20-49-21-69-2 0 0 0 0 0 0-19 19-20 49-2 69l336 356-1189 0c-27 0-49 22-49 49 0 27 22 49 49 49l1189 0-337 357c-17 20-16 51 2 70 20 18 51 17 69-2 0 0 0 0 0 0l414-440c9-9 14-21 14-34l0 0z" transform="translate(0,1000) scale(1, -1)" style="fill: currentcolor;"></path></svg>
                            <span class="scopri">scopri di più</span>
                        </a>
                    </div>                    
                </div>
            </div>
            <div v-show="SearchStatus()">
                <div class="p8 d-flex flex-wrap load-more">
                    <div class="load-cell d-flex flex-wrap justify-content-center cursor-pointer">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-compact-down" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"/>
                            </svg>
                        </div>
                        <div class="load">
                            <span v-on:click="loadmore()">carica articoli</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-compact-down" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
<!--             <div class="p8 d-flex flex-wrap go-up-row">
                <div class="go-up">
                    <a href="#catalogo"><span class="primary-color">↑</span> torna su</a>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from "axios";
var $ = window.jQuery;
export default {
    components: {},
    computed: {
      isLoading:function(){
      return (this.loadingResource || this.loadingResults);
    },
    },

    props: ["default_attribute"],

    created() {
        this.loadResource();
    },

    updated() {
        $('select').selectpicker(); //per la multiselect
        $('.multiple-select').selectpicker();
        this.$jQueryWrapSelect(); //singole select
        $('select').selectpicker('refresh');
        $('select').selectpicker({
            noneResultsText: 'nessun risultato corrispondente'
        });
    },

    data() {
        return {

            prezzi:{min:0,max:100},
            autori:['nessun autore'],
            categorie:[{id:-1,title:'nessuna categoria'}],
            tematismi:[{id:-1,title:'nessun tematismo'}],
            //ordinamenti:['anno','prezzo','titolo','popolarità','rilevanza'],
            ordinamenti:['anno','prezzo','titolo'],

            inputText:"",
            inputPrice:50,

            loadingResource: false,
            loadingResults:false,

            //parametri per filtri
            autoriSelezionati:[],
            categorieSelezionate:[],
            tematismiSelezionati:[],
            //ordinamento
            ordinamento:[],


            //risultati
            risultati:[],
            nextSearchStatus:false,
            nextSearchLink:""
        };
    },
    methods: {
        loadResource(){
            var self= this;
            self.loadingResource=true;
            axios({
                method: "get",
                url: this.default_attribute.concat("/wp-json/api/v1/catalogo-resources"),
                params: {},
            })
            .then(function(response){

                self.prezzi.min=response.data.prezzi.min;
                self.prezzi.max=response.data.prezzi.max; 
                
                // self.inputPrice=((self.prezzi.max-self.prezzi.min)/2)+self.prezzi.min;
                self.inputPrice=self.prezzi.max;

                if (response.data.autori.length>0){
                    self.autori=[];
                
                    response.data.autori.forEach(element => {
                        self.autori.push(element);
                    });
                }
                if (response.data.categorie.length>0){
                    self.categorie=[];
                
                    response.data.categorie.forEach(element => {
                        self.categorie.push(element);
                    });
                }
                if (response.data.tematismi.length>0){
                    self.tematismi=[];
                
                    response.data.tematismi.forEach(element => {
                        self.tematismi.push(element);
                    });
                }                          
                self.loadingResource=false;
                self.search();
            })
            .catch(function(error){});
        },

        autoreSel(autore){
            if (this.autoriSelezionati.includes(autore)){
                var indice;
                indice=this.autoriSelezionati.indexOf(autore);
                this.autoriSelezionati.splice(indice,1);
            }
            else{
                this.autoriSelezionati.push(autore);
            }
        },

        categoriaSel(categoria){
            if (this.categorieSelezionate.includes(categoria.id)){
                var indice;
                indice=this.categorieSelezionate.indexOf(categoria.id);
                this.categorieSelezionate.splice(indice,1);
            }
            else{
                this.categorieSelezionate.push(categoria.id);
            }
        },

        tematismoSel(tematismo){
            if (this.tematismiSelezionati.includes(tematismo.id)){
                var indice;
                indice=this.tematismiSelezionati.indexOf(tematismo.id);
                this.tematismiSelezionati.splice(indice,1);
            }
            else{
                this.tematismiSelezionati.push(tematismo.id);
            }
        },        

        showAutoreX(autore){
            return this.autoriSelezionati.includes(autore);
        },

        showCategoriaX(categoria){
            return this.categorieSelezionate.includes(categoria.id);
        },

        showTematismoX(tematismo){
            return this.tematismiSelezionati.includes(tematismo.id);
        },

        showOrderArrow(ordinamento){
            return this.ordinamento.orderby==ordinamento;
        },
        orderArrow(ordinamento){
            if (this.ordinamento.orderby==ordinamento && this.ordinamento.order=='ASC'){
                return '↑';
            }
            else if (this.ordinamento.orderby==ordinamento && this.ordinamento.order=='DESC'){
                return '↓';
            }            
        },

        order(ordinamento){
            if (this.ordinamento.orderby==ordinamento && this.ordinamento.order=='ASC'){
                this.ordinamento={
                    orderby: ordinamento,
                    order: 'DESC',
                    };                
            }
            else if (this.ordinamento.orderby==ordinamento && this.ordinamento.order=='DESC'){
                this.ordinamento=[];
            }
            else{
                this.ordinamento={
                    orderby: ordinamento,
                    order: 'ASC',
                    };
            }
            this.search();
        },

        SearchStatus(){
            return this.nextSearchStatus;
        },
        search(){
            var self= this;
            self.loadingResults=true;
            self.risultati=[];
            let query={
                testo:this.inputText,
                prezzi:this.inputPrice,
                autori:this.autoriSelezionati,
                categorie:this.categorieSelezionate,
                tematismi:this.tematismiSelezionati,
                ordinamento:this.ordinamento
            };
            
            axios.post(this.default_attribute.concat("/wp-json/api/v1/catalogo"), query)
            .then(function (response) {
                response.data.data.forEach(element => {
                        self.risultati.push(element);
                });

                if (response.data.meta.next){
                    self.nextSearchStatus=true;
                    self.nextSearchLink=response.data.meta.next;
                    self.query=query;
                }
                else{
                    self.nextSearchStatus=false;
                    self.nextSearchLink="";
                    self.query=null;               
                }                
                self.loadingResults=false; 
            })
            .catch(function (error) {
                console.log(error);
            });            

        },

        loadmore(){
            var self= this;
            self.loadingResults=true;
            let query=self.query;
            
            axios.post(this.nextSearchLink, query)
            .then(function (response) {
                response.data.data.forEach(element => {
                        self.risultati.push(element);
                });
                if (response.data.meta.next){
                    self.nextSearchStatus=true;
                    self.nextSearchLink=response.data.meta.next;
                    self.query=query;
                }
                else{
                    self.nextSearchStatus=false;
                    self.nextSearchLink="";
                    self.query=null;    
                }
                self.loadingResults=false; 
            })
            .catch(function (error) {
                console.log(error);
            });            
        }
    },
}
</script>